export default __webpack_public_path__ + "static/media/Promotion1.17183449.png";